import { Box, Checkbox, Chip, Grid } from "@mui/material";
import Helpers from "../../../helpers/helpers";
import Label from "../../../components/Common/Label";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function Review({ formObj, agreement, setAgreement, brandList, categoryList, salesmanList, locationList, modelList, makeList }) {
    let brandName = brandList?.find(brand => brand.id === formObj?.brand_id)?.name || '-';
    let categoryName = categoryList?.find(category => category.id === formObj?.category_id)?.name || '-';
    let subCategoryName = categoryList?.find(category => category.id === formObj?.category_id)?.sub_categories?.find(subCategory => subCategory.id === formObj?.sub_category_id)?.name || '-';
    return (
        <Box mt={3}>
            <Grid container spacing={3}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Accessory Name</div>
                    <div>{formObj?.name || '-'}</div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Brand</div>
                    <div>{brandName || '-'}</div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Category</div>
                    <div>{categoryName || '-'}</div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Sub-Category</div>
                    <div>{subCategoryName || '-'}</div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold">Compatible Models</div>
                    {
                        formObj?.compatible === 'by_make_model' ?
                            formObj?.make_model && formObj?.make_model.length > 0 &&
                            <ul style={{ padding: 5, paddingInline: 18 }}>
                                {
                                    formObj?.make_model.map((item, index) => {
                                        const make_name = makeList?.find(make => make.id === item?.make)?.name || '';
                                        return (
                                            <li key={index}>{make_name} {item?.is_apply_all ? '(All models)' :
                                                item?.model?.length > 0 ?
                                                    "(" + item?.model.map((m) => {
                                                        const model_name = modelList?.find(model => model.id === m)?.name || '';
                                                        return model_name;
                                                    }).join(', ') + ")" : '-'}</li>
                                        )
                                    })
                                }
                            </ul> :
                            <div>Fits all motocycles</div>
                    }
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="text-bold">Price</div>
                    <div>$ {formObj?.selling_price || '0.00'}</div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold">Listing Title</div>
                    <div>{formObj?.title || '-'}</div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold">Listing Description</div>
                    <div dangerouslySetInnerHTML={{ __html: formObj?.description || '-' }}></div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold">Salesman</div>
                    <div>
                        {
                            formObj?.salesman ?
                                <ol style={{ padding: 5, paddingInline: 18 }}>
                                    {
                                        formObj?.salesman?.map((item, index) => {
                                            const name = salesmanList.find(salesman => salesman.id === item?.salesman_id)?.name || '';
                                            // const location_name = locationList.find(location => location.id === item?.location_id)?.name || '';
                                            return (
                                                <li className={index + 1 < formObj.salesman?.length ? "mb-3" : ''} key={index}>
                                                    {name || '-'}, {item?.contact || '-'}, {item?.location_name || '-'}
                                                </li>
                                            )
                                        })
                                    }
                                </ol>
                                : '-'
                        }
                    </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold mb-3">Photos</div>
                    <div>
                        <Grid container spacing={2}>
                            {
                                formObj?.photos && formObj?.photos.length > 0 &&
                                formObj?.photos.map((item, index) => (
                                    <Grid item lg={3} md={4} sm={6} xs={12} key={index}>
                                        <div style={{ position: 'relative', width: 188, }}>
                                            <img src={item?.file_base64 || Helpers.noImage} style={{ height: 120, width: 188, objectFit: 'contain' }} />
                                            {item?.is_thumbnail && <div style={{ position: 'absolute', bottom: 5, right: 5 }}>
                                                <Chip label={"Thumbnail"} style={{ color: "white", border: "1px solid white", backgroundColor: "#D13536", height: "20px", marginLeft: 2, marginBottom: 2 }} />
                                            </div>}
                                        </div>
                                        {/* <img src={item?.file_base64 || Helpers.noImage} style={{ width: 188, height: 120, objectFit: 'contain' }} /> */}
                                    </Grid>
                                ))
                            }
                            {!formObj?.photos && <Grid item sm={12}>-</Grid>}
                        </Grid>
                    </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold mb-2">Video URLs</div>
                    <div>
                        <ol type="1" style={{ padding: 5, paddingInline: 18 }}>
                            <li className="mb-3"><span className="text-bold">Youtube: </span>{formObj?.youtube_url || '-'}</li>
                            <li className="mb-3"><span className="text-bold">Facebook: </span>{formObj?.facebook_url || '-'}</li>
                            <li className="mb-3"><span className="text-bold">Instagram: </span>{formObj?.instagram_url || '-'}</li>
                            <li className="mb-3"><span className="text-bold">Tiktok: </span>{formObj?.tiktok_url || '-'}</li>
                        </ol>
                    </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className="text-bold mb-3">Disclaimer</div>
                    <div className="d-flex align-items-start">
                        <Checkbox checked={agreement}
                            checkedIcon={Helpers.checkIcon()}
                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                            sx={{
                                '&.Mui-checked': {
                                    color: "#a0a0a0",
                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: 18,
                                },
                            }}
                            value={agreement}
                            onChange={(event) => setAgreement(!agreement)} />
                        <div style={{ marginLeft: 10, marginTop: 5 }}>
                            <div>By posting this advertisement, I confirm and agree that:</div>
                            <div className="subheader-2">
                                <ul className="px-3">
                                    <li>
                                        Legitimate Listing: This advertisement is solely for the purpose of selling the specific vehicle described in this listing. It does not
                                        promote any other products, services, or offers.
                                    </li>
                                    <li>
                                        Accuracy & Authenticity: All information provided in this listing is true, accurate, and relates directly to the actual vehicle being offered
                                        for sale.
                                    </li>
                                    <li>
                                        Image Rights: I am the rightful owner of, or have obtained full authorization to use, all images, and other media uploaded with this
                                        advertisement.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Box>
    )
} 